import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import CohortsTableColumns from '../containers/CohortsTableColumns';

const CohortsTableHeader = ({
  category,
  children,
  cohorts,
  columns,
  hideColumns,
  loaderButton,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    {!hideColumns && <CohortsTableColumns category={category} items={cohorts} columns={columns} />}
  </Table.Header>
);

export default CohortsTableHeader;
